import { createRef, useEffect, useState } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { RiAddFill, RiCloseLine, RiDeleteBin2Line, RiMore2Fill } from "react-icons/ri";
import { useSnackbar } from "notistack";
import { CircularProgress, Tooltip, useMediaQuery } from "@material-ui/core";
import KTOffcanvas from "../../_assets/js/offcanvas";
import CustomMenuButton from "../../../app/components/CustomMenuButton";
import SwAlert from "../../../app/components/SwAlert";
import EmptyMessage from "../../../app/components/EmptyMessage";
import Brand from "../brand/Brand";
import Menu from "./Menu";
import MenuList from "./MenuList";
import { deleteExpertsChat } from "../../../app/crud/experts.crud";
import { expertsActions } from "../../../app/store/ducks/experts.duck";
import * as builder from "../../ducks/builder";

const AsideLeft = (props) => {
    let chatActiveTimeout;

    const menuCanvasOptions = {
        baseClass: "kt-aside",
        overlay: true,
        closeBy: "kt_aside_close_btn",
        toggleBy: {
            target: "kt_aside_mobile_toggler",
            state: "kt-header-mobile__toolbar-toggler--active",
        },
    };

    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const asideOffCanvasRef = createRef();
    const { enqueueSnackbar } = useSnackbar();
    const isMediumScreen = useMediaQuery("(max-width: 1024px)");
    const isMediumScreenHeight = useMediaQuery("(max-height: 800px)");
    const [chatActive, setChatActive] = useState(null);
    const [chatLoading, setChatLoading] = useState([]);
    const [expertsHistoricoAnimation, setExpertsHistoricoAnimation] = useState(false);
    const [showExpertsHistorico, setShowExpertsHistorico] = useState(true);
    const [zIndexExpertsHistorico, setzIndexExpertsHistorico] = useState(0);
    const [ktoffCanvas, setKtoffCanvas] = useState(null);

    const {
        menuConfig: {
            aside: { items, footerItems },
        },
        ulClasses,
        layoutConfig,
        asideMenuAttr,
        asideClassesFromConfig,
        experts: { chatList, loadingChatList, selectedChat, showMobileHistory, submittingMessage },
        disableScroll,
    } = useSelector((store) => ({
        layoutConfig: store.builder.layoutConfig,
        disableScroll: builder.selectors.getConfig(store, "aside.menu.dropdown") === "true" || false,
        asideClassesFromConfig: builder.selectors.getClasses(store, {
            path: "aside",
            toString: true,
        }),
        menuConfig: store.builder.menuConfig,
        asideMenuAttr: builder.selectors.getAttributes(store, { path: "aside_menu" }),
        ulClasses: builder.selectors.getClasses(store, {
            path: "aside_menu_nav",
            toString: true,
        }),
        experts: store.experts,
    }));

    const resetHistory = () => {
        dispatch(expertsActions.loadSelectedChat(null));
        dispatch(expertsActions.loadChatList(chatList.filter((c) => c.id)));
        dispatch(expertsActions.loadShowMobileHistory(false));
        setChatActive(null);
    };

    const openExpertsHistorico = () => {
        setExpertsHistoricoAnimation(false);
        setzIndexExpertsHistorico(100);
        setShowExpertsHistorico(true);

        setTimeout(() => {
            setzIndexExpertsHistorico(0);
        }, 500);
    };

    const closeExpertsHistorico = () => {
        setExpertsHistoricoAnimation(true);

        setTimeout(() => {
            setShowExpertsHistorico(false);
        }, 500);
    };

    const handleExpertsChat = (chat, selectedChat) => {
        if (submittingMessage) return;

        if (chat && selectedChat?.id !== chat.id) {
            dispatch(expertsActions.loadSelectedChat(chat));
        } else {
            resetHistory();
        }
        dispatch(expertsActions.loadShowMobileHistory(false));
    };

    const handleDeleteConteudo = (chat) => {
        if (submittingMessage) return;

        SwAlert({
            text: `Tem certeza que deseja excluir o item selecionado? Você não poderá restaurá-lo depois.`,
            showCancelButton: true,
            showConfirmButton: true,
            reverseButtons: true,
            confirmButtonText: "Excluir",
            cancelButtonText: "Cancelar",
            customClass: {
                content: "pt-0 p-32",
                header: "d-none",
                popup: "max-width-30em",
                cancelButton: "btn btn-border btn-large",
                confirmButton: "btn btn-danger btn-large",
            },
            onConfirm: () => {
                setChatActive(null);
                setChatLoading([...chatLoading, chat.id]);

                deleteExpertsChat(chat.id)
                    .then(() => {
                        enqueueSnackbar("Chat excluído com sucesso.", {
                            variant: "success",
                            anchorOrigin: { horizontal: "center", vertical: "bottom" },
                            autoHideDuration: 3000,
                        });

                        dispatch(expertsActions.loadChatList(chatList.filter((c) => c.id !== chat.id)));

                        if (selectedChat?.id === chat.id) {
                            dispatch(expertsActions.loadSelectedChat(null));
                        }
                    })
                    .catch((err) => {
                        SwAlert({
                            title: (err?.response?.data?.errors && Object.values(err?.response?.data?.errors)) ?? `Parece que houve um problema`,
                            text: err?.response?.data?.errors ? null : "Por favor, entre em contato com o suporte.",
                            customClass: {
                                content: err?.response?.data?.errors ? "p-0 pb-32" : "",
                            },
                            confirmButtonText: "Fechar",
                            imageIcon: "error",
                        });
                    })
                    .finally(() => setChatLoading(chatLoading.filter((i) => i !== chat.id)));
            },
        });
    };

    useEffect(() => {
        if (ktoffCanvas) {
            ktoffCanvas.hide();
        }

        if (!pathname.includes("/experts")) {
            resetHistory();
        }
    }, [pathname]);

    useEffect(() => {
        if (asideOffCanvasRef.current && !ktoffCanvas) {
            setKtoffCanvas(new KTOffcanvas(asideOffCanvasRef.current, menuCanvasOptions));
        }

        if (!isMediumScreen) {
            openExpertsHistorico();
        } else {
            if (showMobileHistory) {
                openExpertsHistorico();
            } else {
                closeExpertsHistorico();
            }
        }
    }, [showMobileHistory, isMediumScreen, pathname]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
                resetHistory();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleExpertsChat]);

    return (
        <>
            <button type="button" className="kt-aside-close" id="kt_aside_close_btn">
                <i className="la la-close" />
            </button>

            <div id="kt_aside" ref={asideOffCanvasRef} className={`kt-aside menu-lateral-cor ${asideClassesFromConfig} kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop`}>
                <Brand />

                <div id="kt_aside_menu_wrapper" className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid" style={{ position: "fixed", left: 0, marginBlock: "auto 0", top: isMediumScreen ? 160 : 90, bottom: 90 }}>
                    {disableScroll && <Menu htmlClassService={props.htmlClassService} isMediumScreenHeight={isMediumScreenHeight} />}
                    {!disableScroll && (
                        <PerfectScrollbar options={{ wheelSpeed: 2, wheelPropagation: false }}>
                            <Menu htmlClassService={props.htmlClassService} isMediumScreenHeight={isMediumScreenHeight} />
                        </PerfectScrollbar>
                    )}
                </div>

                <div id="kt_aside_menu_wrapper" className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid" style={{ position: "fixed", bottom: 0, left: 0, background: "transparent" }}>
                    <div id="kt_aside_menu" className={clsx("kt-aside-menu menu-lateral-cor nobg", asideClassesFromConfig)} style={{ backgroundColor: "transparent" }} {...asideMenuAttr}>
                        <ul className={clsx("kt-menu__nav", ulClasses)}>
                            <MenuList currentUrl={pathname} menuConfig={{ aside: { items: footerItems } }} layoutConfig={layoutConfig} />
                        </ul>
                    </div>
                </div>
            </div>

            {showExpertsHistorico && chatList?.length && pathname.includes("/experts") ? (
                <div className={`experts-historico-container ${expertsHistoricoAnimation ? "slide-up" : "slide-down"}`} style={{ zIndex: zIndexExpertsHistorico }}>
                    <span className="experts-historico-title">
                        <button type="button" className="btn-icon experts-historico-close position-absolute" onClick={() => dispatch(expertsActions.loadShowMobileHistory())}>
                            <RiCloseLine size={28} color="#9CA3AF" />
                        </button>
                        Histórico
                    </span>

                    {loadingChatList ? (
                        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
                            <CircularProgress />
                        </div>
                    ) : chatList?.length ? (
                        <div className="experts-historico-list">
                            <div key="chatItem-1" className="experts-historico-item" style={{ marginBottom: 24 }} onClick={resetHistory}>
                                <div>
                                    <RiAddFill size={20} color="#9CA3AF" />
                                </div>

                                <span className="tt-16 medium color-dark-6 m-0">Novo chat</span>
                            </div>

                            {chatList?.map((item, idx) => {
                                const expert = item.expert;

                                return (
                                    <div key={`chatItem${idx}`} className={`experts-historico-item${(chatActive || selectedChat?.id) === item.id ? " active" : ""}`} onClick={() => handleExpertsChat(chatLoading.length ? null : item, selectedChat)}>
                                        <Tooltip title={expert?.exp_name} placement="bottom">
                                            <img className="experts-historico-item-img" src={expert?.picture?.url} alt="expAvatar" />
                                        </Tooltip>

                                        <Tooltip title={item.name} placement="bottom-start">
                                            <span>{item.name}</span>
                                        </Tooltip>

                                        {chatLoading.includes(item.id) ? (
                                            <div className="d-flex align-items-center">
                                                <CircularProgress size={12} />
                                            </div>
                                        ) : item.id ? (
                                            <CustomMenuButton
                                                variant="experts"
                                                className="experts-historico-item-menu"
                                                items={[
                                                    {
                                                        label: <span className="tt-16 medium color-red">Excluir</span>,
                                                        icon: <RiDeleteBin2Line size={16} color="#F23030" />,
                                                        onClick: (event) => {
                                                            event.stopPropagation();
                                                            handleDeleteConteudo(item);
                                                        },
                                                    },
                                                ]}
                                                handleMenu={(status) => {
                                                    if (submittingMessage) return;

                                                    if (status) {
                                                        setChatActive(item.id);
                                                    } else {
                                                        clearTimeout(chatActiveTimeout);
                                                        chatActiveTimeout = setTimeout(() => {
                                                            setChatActive(null);
                                                        }, 300);
                                                    }
                                                }}
                                            >
                                                <RiMore2Fill size={24} color="#9CA3AF" />
                                            </CustomMenuButton>
                                        ) : null}
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="h-100 d-flex justify-content-center" style={{ marginTop: isMediumScreen ? "10dvh" : "100%" }}>
                            <EmptyMessage message="Nenhuma conversa iniciada" />
                        </div>
                    )}
                </div>
            ) : null}
        </>
    );
};

export default AsideLeft;
